import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import useSWR from 'swr'
import { BASE_URL } from '../constants'
import { repeat, SeriesForPlot } from '../pages/stats/utils'
import { getReq } from '../service/API'
import { Analytics, ContractGoal, EventType } from '../Types'
import { ExpectedRandomizations } from './useStatsSingleProject'
import { ProjectsTableData } from '../pages/stats/allProjects/charts/ProjectsTable'

export type EnrollmentAnalyticData = {
  stateType: EventType
  _id: string
  siteId: string
  events: { createdAt: string; eventType: EventType }[]
}

export const useStatsAllProjects = () => {
  const [searchParams] = useSearchParams()
  const p = BASE_URL + `/dashboard/stats-all/?${searchParams.toString()}`
  const [searching, setSearching] = useState<boolean>(false)
  // lav responde typen.
  const fetchWithLog = async (p: string) => {
    try {
      setSearching(true)
      const res = await getReq(p)
      console.log(p.replaceAll(BASE_URL ?? '', ''), res)
      setSearching(false)
      return res
    } catch (err) {
      console.error(err)
      setSearching(false)
      throw err
    }
  }

  const { data, error, mutate } = useSWR(p, fetchWithLog, {
    suspense: true,
    revalidateIfStale: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  })

  const hasMounted = useRef(false)
  useEffect(() => {
    if (hasMounted.current) {
      // Trigger a revalidation when `p` changes, but only after the initial mount
      mutate()
    } else {
      hasMounted.current = true
    }
  }, [p, mutate])

  const res:
    | undefined
    | {
        statsPerProject: {
          expectedRandomizations: ExpectedRandomizations
          numSignUps: number
          randoTimelineSeries: SeriesForPlot
          analytics: Analytics
          newestGoal: ContractGoal
          projectTitle: string
          color: string
          /** multiply by this value to get a value relative to the goal in percentage. I.e. to display the percentage */
          relativeToGoalPercentage: number
          tableData: ProjectsTableData
        }[]
        /** which projects havent setup analytics?? */
        missingAnalytics: string[]
        countries: string[]
      } = data?.data

  // give some colors
  if (res) {
    res.statsPerProject.sort((a, b) => a.projectTitle.localeCompare(b.projectTitle))
    const colors = getColors()
    res.statsPerProject.forEach((project, idx) => {
      project.color = colors[idx]
      project.relativeToGoalPercentage = (1 / project.newestGoal.totalRandomizations) * 100
    })
  }

  return {
    statsPerProject: res?.statsPerProject,
    countries: res?.countries,
    isLoading: !error && !data,
    isError: error,
    searching,
  }
}

function getColors() {
  return repeat(
    [
      '#008FFB',
      '#00E396',
      '#FEB019',
      '#FF4560',
      '#001bb3',
      '#b0455c',
      '#8D5B4C',
      '#F86624',
      '#1B998B',
      '#6d42ff',
      '#D7263D',
      '#2E294E',
      '#546E7A',
    ],
    3
  )
}
